module.exports = __webpack_public_path__ + "img/slide11-piece-31.f28732bc.png";